/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Component { 
    serviceNumber?: string;
    id?: number;
    type?: Component.TypeEnum;
    name?: string;
    posX?: number;
    posY?: number;
    customizable?: boolean;
}
export namespace Component {
    export type TypeEnum = 'None' | 'Termination' | 'PromptAndCollect' | 'Queue' | 'LoginLogout' | 'Router' | 'GeoRouter' | 'ExtLookup' | 'IntLookup' | 'Screen' | 'TimeRouter' | 'Announcement' | 'CustomMapper' | 'CustomSwitch' | 'CustomDate' | 'LoadShare' | 'HuntGroup' | 'Charging' | 'TerminalState' | 'PNPLookup' | 'MobileZone' | 'Selector' | 'CalendarLookup' | 'Barring' | 'PNPCheck' | 'VPNSMSSender' | 'VPNTermination' | 'VPNAnnouncement' | 'VPNTime' | 'VPNCallback' | 'CustomMenu' | 'SendSMS' | 'CallbackQueue' | 'MainHuntGroup' | 'Prompt' | 'VPNPrompt' | 'Capability' | 'VPNPromptAndCollect' | 'Absence' | 'Conference' | 'Record' | 'VPNNumberTranslation' | 'CallPickup' | 'SendMessage' | 'ReleaseCall' | 'VPNDate';
    export const TypeEnum = {
        None: 'None' as TypeEnum,
        Termination: 'Termination' as TypeEnum,
        PromptAndCollect: 'PromptAndCollect' as TypeEnum,
        Queue: 'Queue' as TypeEnum,
        LoginLogout: 'LoginLogout' as TypeEnum,
        Router: 'Router' as TypeEnum,
        GeoRouter: 'GeoRouter' as TypeEnum,
        ExtLookup: 'ExtLookup' as TypeEnum,
        IntLookup: 'IntLookup' as TypeEnum,
        Screen: 'Screen' as TypeEnum,
        TimeRouter: 'TimeRouter' as TypeEnum,
        Announcement: 'Announcement' as TypeEnum,
        CustomMapper: 'CustomMapper' as TypeEnum,
        CustomSwitch: 'CustomSwitch' as TypeEnum,
        CustomDate: 'CustomDate' as TypeEnum,
        LoadShare: 'LoadShare' as TypeEnum,
        HuntGroup: 'HuntGroup' as TypeEnum,
        Charging: 'Charging' as TypeEnum,
        TerminalState: 'TerminalState' as TypeEnum,
        PNPLookup: 'PNPLookup' as TypeEnum,
        MobileZone: 'MobileZone' as TypeEnum,
        Selector: 'Selector' as TypeEnum,
        CalendarLookup: 'CalendarLookup' as TypeEnum,
        Barring: 'Barring' as TypeEnum,
        PNPCheck: 'PNPCheck' as TypeEnum,
        VPNSMSSender: 'VPNSMSSender' as TypeEnum,
        VPNTermination: 'VPNTermination' as TypeEnum,
        VPNAnnouncement: 'VPNAnnouncement' as TypeEnum,
        VPNTime: 'VPNTime' as TypeEnum,
        VPNCallback: 'VPNCallback' as TypeEnum,
        CustomMenu: 'CustomMenu' as TypeEnum,
        SendSMS: 'SendSMS' as TypeEnum,
        CallbackQueue: 'CallbackQueue' as TypeEnum,
        MainHuntGroup: 'MainHuntGroup' as TypeEnum,
        Prompt: 'Prompt' as TypeEnum,
        VPNPrompt: 'VPNPrompt' as TypeEnum,
        Capability: 'Capability' as TypeEnum,
        VPNPromptAndCollect: 'VPNPromptAndCollect' as TypeEnum,
        Absence: 'Absence' as TypeEnum,
        Conference: 'Conference' as TypeEnum,
        Record: 'Record' as TypeEnum,
        VPNNumberTranslation: 'VPNNumberTranslation' as TypeEnum,
        CallPickup: 'CallPickup' as TypeEnum,
        SendMessage: 'SendMessage' as TypeEnum,
        ReleaseCall: 'ReleaseCall' as TypeEnum,
        VPNDate: 'VPNDate' as TypeEnum
    };
}
